import React from 'react';
import { Dialog } from 'primereact/dialog';

interface PopupProps {
    visible: boolean;
    onDialogHide: () => void;
}

const Popup: React.FC<PopupProps> = ({ visible, onDialogHide }) => {
    return (
        <Dialog
            visible={visible}
            position="top"
            style={{
                width: '30vw',
                border: '1px solid rgba(0, 0, 0, .2)',
                borderRadius: '10px',
                margin: '5px',
                padding: '5px',
                backgroundColor: '#fff'
            }}
            onHide={onDialogHide}
            draggable={false}
            resizable={false}
            className="notify-popup-2"
        >
            <div className="modal-body">
                <div className="text-left tour-notify-msg p-0">
                    <div className="modal-body form-t1">
                        <div className="small-font text-center e-services-details">
                            <span className="svg-icons">
                                <svg fill="none" height="88" viewBox="0 0 88 88" width="88" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="44" cy="44" fill="#FFF5F5" r="44"></circle>
                                    <path
                                        d="M46.0626 21.9082C45.2553 20.3822 42.7446 20.3822 41.9373 21.9082L20.9373 61.5748C20.7482 61.9304 20.6545 62.3288 20.6653 62.7313C20.676 63.1338 20.7908 63.5267 20.9985 63.8717C21.2063 64.2166 21.4998 64.5019 21.8505 64.6996C22.2013 64.8974 22.5973 65.0009 22.9999 65.0002H64.9999C65.4023 65.001 65.7981 64.8976 66.1486 64.6999C66.4991 64.5023 66.7924 64.2172 66.9999 63.8724C67.2074 63.5276 67.322 63.135 67.3326 62.7327C67.3432 62.3305 67.2494 61.9324 67.0603 61.5772L46.0626 21.9082ZM46.3333 58.0002H41.6666V53.3335H46.3333V58.0002ZM41.6666 48.6668V37.0002H46.3333L46.3356 48.6668H41.6666Z"
                                        fill="#ED1C24"
                                    />
                                </svg>
                            </span>
                            <h6
                                style={{
                                    marginBottom: '.5rem',
                                    fontWeight: 500,
                                    lineHeight: 1.2,
                                    fontSize: "1rem"
                                }}
                            >
                                You are already subscribed to a combo plan. If you want to change your subscription plan to a different one, please get in touch with us.
                            </h6>

                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer" style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="col-lg-12 text-center tour-notify-msg-footer">
                    <button
                        className="btn-orange-bg-1 mt-3 mt-lg-0"
                        style={{
                            textDecoration: 'none',
                            backgroundColor: '#ED1C24',
                            color: '#fff',
                            padding: '0.5rem 2rem',
                            borderRadius: '50px',
                            fontWeight: 'bold',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                        onClick={() => window.location.href = '/contactus#contactus'}
                    >
                        Contact Us
                    </button>

                </div>
            </div>
        </Dialog>
    );
};

export default Popup;
